import { types } from "mobx-state-tree"

const VictoryPhoto = types.model('VictoryPhoto', {
    photo_url: types.string,
    filename: types.maybeNull(types.string),
    storage_url: types.maybeNull(types.string),
})

export default VictoryPhoto
